import React from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Iconify from "../../components/Iconify";
import Reveal from "../../components/Reveal";
import { FAQ_ITEMS } from "./content";

export default function Faq() {
  return (
    <Box sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        <Stack spacing={1} sx={{ mb: 5, textAlign: "center" }}>
          <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 700, letterSpacing: 2 }}>
            Fragen & Antworten
          </Typography>
          <Typography variant="h3" component="h2" fontWeight={800} letterSpacing="-0.02em">
            Was andere Schulen wissen wollen
          </Typography>
        </Stack>

        <Stack spacing={1.5}>
          {FAQ_ITEMS.map((item, i) => (
            <Reveal key={item.q} delay={Math.min(i, 4) * 50}>
              <Accordion
                disableGutters
                elevation={0}
                sx={{
                  border: "1px solid",
                  borderColor: "grey.200",
                  borderRadius: "12px !important",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<Iconify icon="mdi:chevron-down" width={22} />}
                  sx={{ px: 3, py: 0.5 }}
                >
                  <Typography component="h3" fontWeight={700}>{item.q}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ px: 3, pb: 3 }}>
                  <Typography sx={{ color: "grey.600" }}>{item.a}</Typography>
                </AccordionDetails>
              </Accordion>
            </Reveal>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
